<template>
  <list class="voucher-segment-list"
        :list="list"
        :infiniteId="infiniteId"
        :headers="headers"
        :loading="loading"
        @load="load">
    <template slot="default"
              slot-scope="slotProps">
      <voucher-segment-list-item :item="slotProps.item"
                                 @reload="emitReload" />
    </template>
  </list>
</template>

<script>
import List from "@components/generic/list/List.vue";
import VoucherSegmentListItem from "@components/modules/voucher/segment/list/item/VoucherSegmentListItem.vue";

export default {
  components: {
    List,
    VoucherSegmentListItem,
  },

  data() {
    return {
      loading: false,
      headers: [
        { text: "Nome", value: "name", sortable: false },
        { text: "Tipo", value: "type", sortable: false },
        { text: "Uso diário único", value: "onceTimePerDay", sortable: false },
        { text: "Data de criação", value: "onceTimePerDay", sortable: false },
      ],
      list: [],
    };
  },

  mixins: [],

  props: {
    infiniteId: {
      type: Number,
      required: true,
    },
  },

  methods: {
    async load($state) {
      try {
        const voucherSegmentList = await this.$api.core.voucher.segment.list();

        this.list = voucherSegmentList;

        $state.complete();
      } catch (error) {
        console.log(error);
      }
    },
    emitReload() {
      this.$emit("reload");
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.voucher-segment-list {
  ::v-deep .v-table__overflow {
    overflow: visible;
  }
}
</style>